/**
 * @packageDocumentation
 * Constructs the animated start page, including hero art, call-to-action button, and entry transitions into the card screen.
 */
/** 
 * Class representing the start page of the game
 * @extends PIXI.Container
 */
import * as PIXI from "pixi.js"; 
import { Assets } from 'pixi.js'; 
import { GridProperties } from "../config"; 
import { brightnessFilter, font_main } from "./global";
import {betArea} from "./betArea"

export class createStartPage extends PIXI.Container{
    /** Graphics object used as a mask for the grid */
    private GridMask:PIXI.Graphics;
    /** Container for the start button */
    private startButContainer!:PIXI.Container;
    /** Container for the betting area */
    public BetAreaContainer!:betArea;

    /**
     * Creates an instance of createStartPage
     * Initializes the grid mask and start text
     */
    constructor(){
        super();
        this.GridMask = new PIXI.Graphics()
            .rect(0, 0, GridProperties.TotalColumns*((GridProperties.boxWidth+GridProperties.gapBtwnBoxes)), GridProperties.TotalRows*((GridProperties.boxHeight+GridProperties.gapBtwnBoxes)))
            .fill({ color: "green", alpha: 0.9}); // Use object syntax for fill
        this.GridMask.x = -(GridProperties.boxWidth+GridProperties.gapBtwnBoxes)/2
        this.GridMask.y = -(GridProperties.boxHeight+GridProperties.gapBtwnBoxes)/2
        this.GridMask.alpha = 0
        
        this.addChild(this.GridMask)
        this.formStartText()

    };

    /**
     * Creates and positions the start game text
     * Adds text with styling and stroke effects
     * Centers the text on the grid mask
     */
    formStartText(){
        let startText:PIXI.Text = new PIXI.Text({text:"START\nNEW GAME",style:{
            fontFamily: font_main, 
            align:"center",
            fill: 'white', 
            fontSize: 50,
            fontWeight: 'lighter',
            stroke:{
                color:"black",
                width:4,
                join:"round"

            },
            // letterSpacing:2
        }});
        startText.anchor.set(0.5);
        startText.x = this.GridMask.x+this.GridMask.width/2;
        startText.y = this.GridMask.y+this.GridMask.height/2; 
        // this.addChild(startText)
    }

}
